// @flow
import React from 'react';
import { isEmpty } from 'lodash';

import { truncate } from 'Components/utils/string/string.util.js';

import { ContentSlideShow } from 'Components/frameworks/content-slideshow/ContentSlideShow.jsx';
import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink.jsx';
import Image from 'Components/frameworks/image/Image.jsx';
import { TrackClick } from 'Tracking/track-click/TrackClick';

export type ReviewProps = {
  authors?: Array<string>,
  date?: string,
  datetime?: string,
  rating?: number,
  ratingImageUrl?: string,
  text: string,
  title: string,
  url: string,
};

type TripAdvisorReviewsProps = {
  className?: string,
  maxLengthOfReview?: number,
  reviews: Array<ReviewProps>,
};

export function TripAdvisorReviews(props: TripAdvisorReviewsProps) {
  const { className, maxLengthOfReview = 255, reviews = [] } = props;

  if (isEmpty(reviews)) return null;

  return (
    <section className={className}>
      <ContentSlideShow>
        {reviews.map(
          ({ datetime, rating, ratingImageUrl, authors = [], date, text, title, url }) => {
            if (isEmpty(text)) return null;

            return (
              <TrackClick
                as={DynamicLink}
                trackingData={{
                  categoryGA: 'resort',
                  actionGA: 'practicalInfos',
                  labelGA: 'tripAdvisorReviews',
                }}
                className="block text-inherit"
                key={url}
                target="_blank"
                url={url}
              >
                <blockquote cite={url} className="m-0">
                  {title && (
                    <p className="reset-paragraph font-bold mb-2" title={title}>
                      {title}
                    </p>
                  )}
                  <div className="flex mb-3">
                    <Image
                      className="block mb-1"
                      altMsg={rating}
                      dontChangeAnything
                      imageUrl={ratingImageUrl}
                    />
                    <time dateTime={datetime} className="rtl:ml-4 text-sm">
                      {date}
                    </time>
                  </div>
                  {text && (
                    <p className="reset-paragraph mb-3 decorator-quote" title={text}>
                      {truncate(text, maxLengthOfReview)}
                    </p>
                  )}
                  <small className="block text-sm">
                    <span>
                      {authors.map(author => {
                        return (
                          <span key={author} data-testid="TripAdvisorReviewsAuthor">
                            {author}
                            <br />
                          </span>
                        );
                      })}
                    </span>
                  </small>
                </blockquote>
              </TrackClick>
            );
          },
        )}
      </ContentSlideShow>
    </section>
  );
}
